import Vue from 'vue'
import * as types from 'store/mutation-types'

function filterItems(data, id) {
  return data.filter(item => item.id === id)[0]
}

function normalizeSimpleObject(object) {
  if (!object) return
  const standardObj = {
    id: object.id,
    name: object.name,
    items: null
  }
  if (object.items) {
    standardObj.items = [...object.items]
  } else if (object.data) {
    standardObj.items = [...object.data]
  }
  return standardObj
}

function normalizeHkSpecialObject(key, object) {
  if (!object) return
  const descKeys = ['hkntlDesc', 'mainDesc']
  const descName = Vue.t('discovery.top-gainers')
  const ascName = Vue.t('discovery.top-losers')
  const standardObj = {
    id: key,
    name: object.name,
    items: null
  }
  if (object.items) {
    standardObj.items = [...object.items]
  }
  if (descKeys.includes(key)) {
    standardObj.name = `${standardObj.name} ${descName}`
  } else {
    standardObj.name = `${standardObj.name} ${ascName}`
  }
  return standardObj
}

function normalizeAhPremiumObject(object) {
  if (!object) return
  const standardObj = {
    id: object.id,
    name: object.name,
    items: []
  }
  if (object.data) {
    standardObj.items = object.data.map(item => {
      const hkStock = {
        symbol: item[0][0],
        name: item[0][1],
        price: item[0][2],
        changeRate: item[0][3],
        market: item[0][4],
        status: item[0][5]
      }
      const aStock = {
        symbol: item[1][0],
        name: item[1][1],
        price: item[1][2],
        changeRate: item[1][3],
        market: item[1][4],
        status: item[1][5]
      }
      return {
        name: hkStock.name,
        symbol: hkStock.symbol,
        hkStock,
        aStock,
        premium: item[2]
      }
    })
  }
  return standardObj
}
const actions = {
  loadHkTodayDiscovery({ commit, getters }, { market, category }) {
    const param = getters.discoveryFilter
    const unusualList = () =>
      Vue.http
        .get('~stock/hkstock/explore/unusual', {
          params: { limit: 50, ...param.hkUnFilter }
        })
        .then(resp => {
          if (resp.data.ret === 0) {
            return resp.data
          }
        })
    const hotList = () =>
      Vue.http
        .get('~stock/hkstock/explore/hot', {
          params: { limit: 50 }
        })
        .then(resp => {
          if (resp.data.ret === 0) {
            return resp.data
          }
        })

    return Promise.all([unusualList(), hotList()]).then(([unusual, hot]) => {
      const watchlistTop = filterItems(hot.items, 'watchlistTop')
      const volumeTop = filterItems(hot.items, 'volumeTop')
      const amountTop = filterItems(hot.items, 'amountTop')
      const changeRate5MinTop = filterItems(unusual.items, 'changeRate5MinTop')
      const changeRate5MinDrop = filterItems(
        unusual.items,
        'changeRate5MinDrop'
      )
      const amplitudeTop = filterItems(unusual.items, 'amplitudeTop')
      const turnoverTop = filterItems(unusual.items, 'turnoverTop')
      const payload = {
        market,
        category,
        watchlistTop: normalizeSimpleObject(watchlistTop),
        volumeTop: normalizeSimpleObject(volumeTop),
        amountTop: normalizeSimpleObject(amountTop),
        changeRate5MinTop: normalizeSimpleObject(changeRate5MinTop),
        changeRate5MinDrop: normalizeSimpleObject(changeRate5MinDrop),
        amplitudeTop: normalizeSimpleObject(amplitudeTop),
        turnoverTop: normalizeSimpleObject(turnoverTop)
      }
      return commit(types.LOAD_DISCOVERY_DATA, payload)
    })
  },
  loadHkSpecialDiscovery({ commit }, { market, category }) {
    const hkRanking = (id, order) =>
      Vue.http
        .get(`~stock/hkstock/ranking/${id}`, {
          params: { order }
        })
        .then(resp => {
          if (resp.data.ret === 0) {
            return resp.data
          }
        })

    const hkAhPremium = () =>
      Vue.http.get('~stock/hkstock/market/ah/premium').then(resp => {
        if (resp.data.ret === 0) {
          return resp.data
        }
      })

    return Promise.all([
      hkRanking('package_hkntl', 'desc'),
      hkRanking('package_hkntl', 'asc'),
      hkRanking('main', 'desc'),
      hkRanking('main', 'asc'),
      hkAhPremium()
    ]).then(([hkntlDesc, hkntlAsc, mainDesc, mainAsc, ahPremium]) => {
      const payload = {
        market,
        category,
        hkntlDesc: normalizeHkSpecialObject('hkntlDesc', hkntlDesc),
        hkntlAsc: normalizeHkSpecialObject('hkntlAsc', hkntlAsc),
        mainDesc: normalizeHkSpecialObject('mainDesc', mainDesc),
        mainAsc: normalizeHkSpecialObject('mainAsc', mainAsc),
        ahPremium: normalizeAhPremiumObject(ahPremium)
      }
      return commit(types.LOAD_DISCOVERY_DATA, payload)
    })
  }
}

export default {
  actions
}
